import { NodeApi, RangeApi } from 'platejs'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { editorDebug } from '../editorDebug'

const debug = editorDebug.extend('withoutLosingSelection')

export const withoutLosingSelection = (
  editor: BufferEditor,
  fn: () => void,
): void => {
  const { selection } = editor
  const selectionRef = selection && editor.api.rangeRef(selection)

  fn()

  if (selectionRef?.current) {
    let newSelection = { ...selectionRef.current }

    if (RangeApi.isCollapsed(newSelection)) {
      /**
       * Some operations leave the selection at the end of the text inside a void element and
       * this would prevent the user to keep typing because void elements are non editable.
       * The code below tries to set the selection in the point after that which should be
       * an empty text node (see https://docs.slatejs.org/concepts/11-normalizing)
       */
      const entry = editor.api.above({
        at: newSelection,
        voids: true,
      })
      const isAncestorVoid =
        !!entry && !NodeApi.isEditor(entry[0]) && editor.api.isVoid(entry[0])
      const pointAfter = isAncestorVoid && editor.api.after(newSelection)

      newSelection = pointAfter
        ? { anchor: pointAfter, focus: pointAfter }
        : newSelection
    }

    debug('resetting selection', newSelection)
    editor.tf.setSelection(newSelection)

    selectionRef.unref()
  }
}
